import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-metric-bar',
  templateUrl: './metric-bar.component.html',
  styleUrls: ['./metric-bar.component.css']
})
export class MetricBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
